/**
 * Status Type Enum
 * Defines all possible status values with semantic meaning across the application
 *
 * @example
 * ```tsx
 * const user = { status: StatusType.Active };
 * <StatusBadge status={StatusType.Active} />
 * ```
 */
export enum StatusType {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
  Idle = 'idle',
}

/**
 * Type guard to check if a value is a valid StatusType
 */
export function isStatusType(value: unknown): value is StatusType {
  return (
    typeof value === 'string' &&
    Object.values(StatusType).includes(value as StatusType)
  );
}

/**
 * Get all status type values as an array
 */
export function getAllStatusTypes(): readonly StatusType[] {
  return Object.values(StatusType);
}
